import SelectOptionList from './SelectOptionList';

export default {
  mixins: [SelectOptionList],
  props: {
    expandedByDefault: { type: Boolean },
    labelledBy: { type: String, default: undefined },
  },
};
